import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import './Contact.css';
import './Contact-responsive.css';

import { Ripple } from "primereact/ripple";
import { DataTable } from 'primereact/datatable';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import { Column } from 'primereact/column';
import { Avatar } from 'primereact/avatar';
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";

import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import { goToTop } from "../../Components/goToTop";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { fetchAllContact } from "../../Controllers/Thunks/contactThunks";
import { Professional } from "../../Controllers/Types/ProfessionalInterface";
import { Employee } from "../../Controllers/Types/EmployeeInterface";
import { setActiveTab, setSelectedComClient, setSelectedDomClient, setSelectedProfessional, setSelectedEmployee, setStatus } from "../../Controllers/Slices/contactSlice";
import { Client } from "../../Controllers/Types/ClientInterface";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { getLoginUserRoleName, UserRoleName } from "../../Utils/LoginUserRoleName";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

const Contact: React.FC = () => {
    const dispatch = useAppDispatch()
    const status = useAppSelector((state) => state.contact.status)
    const activeTab = useAppSelector((state) => state.contact.activeTab)
    const [allContacts, setAllContacts] = useState<any[]>([]);
    const employees: Employee[] = useAppSelector((state) => state.contact.employees)
    const professionals: Professional[] = useAppSelector((state) => state.contact.professionals)
    const clients: Client[] = useAppSelector((state) => state.contact.clients)
    const loading = useAppSelector((state) => state.contact.loading)
    const error = useAppSelector((state) => state.contact.error)

    const [selectedEmployeeType, setSelectedEmployeeType] = useState<string | null>(null);
    const [employeeTypes] = useState<string[]>(['Employee', 'Temporary Employee', 'Area Manager', 'Building Inspector', 'Plan Check Engineer']);
    const [validEmployeeTypes, setValidEmployeeTypes] = useState<string[]>([]);

    const [selectedProfessionalType, setSelectedProfessionalType] = useState<string | null>(null);
    const [professionalEmployeeTypes] = useState<string[]>(['Company', 'Self Employee']);

    const [selectedClientType, setSelectedClientType] = useState<string | null>(null);
    const [clientEmployeeTypes] = useState<string[]>(['Commercial Client', 'Domestic Client']);

    const [showAddContactModal, setShowAddContactModal] = useState<boolean>(false);

    const [contactSearchKey, setContactSearchKey] = useState<string>("");


    /* For permission */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };


    /*  */

    const [showAddContactTypeModal, setShowAddContactTypeModal] = useState<boolean>(false);
    const [addContactState, setAddContactState] = useState<'Employee' | 'Professional' | 'Client' | null>(null)

    //const [filteredEmployeeContacts, setFilteredEmployeeContacts] = useState<Employee[]>([]);


    const isPermissionAll = useCanEdit('Contact', 'All');
    const isPermissionEmployee = useCanEdit('Contact', 'Employee');
    const isPermissionProfessional = useCanEdit('Contact', 'Professional');
    const isPermissionClient = useCanEdit('Contact', 'Client');
    const isPermissionAdd = useCanEdit('Contact', 'add')

    /* ******************************* Contact ********************************** */

    // Get logged in user role name
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);

    useEffect(() => {
        const storedTab = localStorage.getItem('activeContactsDataViewMode');

        let defaultTab: string | null = null;

        if (isPermissionAll) {
            defaultTab = 'all';
        } else if (isPermissionEmployee) {
            defaultTab = 'employee';
        } else if (isPermissionProfessional) {
            defaultTab = 'professional';
        } else if (isPermissionClient) {
            defaultTab = 'client';
        }

        const isStoredTabAllowed =
            (storedTab === 'all' && isPermissionAll) ||
            (storedTab === 'employee' && isPermissionEmployee) ||
            (storedTab === 'professional' && isPermissionProfessional) ||
            (storedTab === 'client' && isPermissionClient);

        const finalTab = isStoredTabAllowed ? storedTab : defaultTab;

        if (finalTab) {
            dispatch(setActiveTab(finalTab));
        }

        setContactSearchKey('');

    }, [
        dispatch,
        isPermissionAll,
        isPermissionEmployee,
        isPermissionProfessional,
        isPermissionClient
    ]);


    useEffect(() => {
        //if(status === 0){
        dispatch(fetchAllContact());
        // dispatch(setActiveTab('employee'));

        dispatch(setStatus(1))
        // }

    }, [dispatch]);

    useEffect(() => {
        const combinedContacts = [...employees, ...professionals, ...clients]
        setAllContacts(combinedContacts)
    }, [employees, professionals, clients])


    const filteredAllContacts = useMemo(() => {
        const searchKey = contactSearchKey.toLowerCase().trim();

        return allContacts.filter(({ first_name, last_name, email, mobile }) => {
            const fullName = `${first_name ?? ""} ${last_name ?? ""}`.toLowerCase();

            return (
                !searchKey ||
                (first_name ?? "").toLowerCase().includes(searchKey) ||
                fullName.includes(searchKey) ||
                (last_name ?? "").toLowerCase().includes(searchKey) ||
                (email ?? "").toLowerCase().includes(searchKey) ||
                (mobile ?? "").toLowerCase().includes(searchKey)
            );
        });
    }, [allContacts, contactSearchKey]);


    const filteredEmployeeContacts = useMemo(() => {
        const searchKey = contactSearchKey.toLowerCase().trim();

        return employees.filter(({ first_name, last_name, email, mobile, contactSubType }) => {
            const matchesType = !selectedEmployeeType || contactSubType === selectedEmployeeType;

            const matchesSearch =
                !searchKey ||
                (first_name ?? "").toLowerCase().includes(searchKey) ||
                (last_name ?? "").toLowerCase().includes(searchKey) ||
                (email ?? "").toLowerCase().includes(searchKey) ||
                (mobile ?? "").toLowerCase().includes(searchKey);

            return matchesType && matchesSearch;
        });
    }, [employees, selectedEmployeeType, contactSearchKey]);


    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');


    const handleTabChange = (tab: string): void => {
        localStorage.setItem('activeContactsDataViewMode', tab);
        dispatch(setActiveTab(tab));
    }

    const handleCloseAddContactModal = () => {
        setShowAddContactModal(false);
    }

    const addContactModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add contact for
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseAddContactModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );
    /* ************************************************************************** */


    /* ***************************** All contacts ******************************* */
    const contactAvatarBody = (rowData: any) => {
        return (
            <div className="contact_avatar_area">
                <Avatar
                    image={`${rowData['profile_image']}`}
                    className="contact_avatar"
                    size="xlarge"
                    shape="circle"
                />
            </div>
        );
    };

    const contactNameBody = (rowData: any) => {
        var first_name = '';
        var last_name = '';

        if (rowData.contactSubType === "Company") {
            first_name = rowData.subContact[0].first_name;
            last_name = rowData.subContact[0].last_name;
        } else {
            first_name = rowData.first_name;
            last_name = rowData?.last_name;
        }
        return (
            <div className="table_row_data text-capitalize">
                {first_name || last_name ? `${first_name ?? ''} ${last_name ?? ''}`.trim() : '---'}
            </div>
        );
    }

    const contactRoleBody = (rowData: any) => {
        var role_name = '';

        if (rowData.contactSubType === "Company") {
            role_name = rowData.subContact[0].role_name;
        } else {
            role_name = rowData.role_name;
        }
        return (
            <div className="table_row_data text-capitalize">
                {role_name ? role_name : '---'}
            </div>
        );
    }

    const contactPhoneBody = (rowData: any) => {
        var phone_number = '';

        if (rowData.contactSubType === "Company") {
            phone_number = rowData.subContact[0].pimary_phone_no;
        } else {
            phone_number = rowData.mobile;
        }

        return (
            <React.Fragment>
                {phone_number ? (
                    <Link
                        to={`tel:${phone_number}`}
                        className="text_no_wrap is_link is_contact_element phone"
                    >
                        {phone_number}
                    </Link>
                ) : (
                    <span>---</span>
                )}
            </React.Fragment>
        );
    }

    const contactSubTypeBody = (rowData: any) => {
        const contactType = rowData.contactType;
        const contactSubType = rowData.contactSubType;

        return (
            <React.Fragment>
                {contactType === 'Employee' ? (
                    <React.Fragment>
                        <Tooltip
                            key={`emp_type${rowData.contactId}`}
                            id={`emp_type${rowData.contactId}`}
                            target={`.emp_type${rowData.contactId}`}
                        />

                        <div className="table_row_data text-center">
                            {contactSubType === 'Employee' ? (
                                <span
                                    className={`emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`${loginUserRoleName === 'building inspector company' ? 'Employee' : 'Permanent Employee'}`}
                                    data-pr-position="top"
                                >{loginUserRoleName === 'building inspector company' ? 'EM' : 'PE'}</span>
                            ) : contactSubType === 'Temporary Employee' ? (
                                <span
                                    className={`emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Temporary Employee`}
                                    data-pr-position="top"
                                >TE</span>
                            ) : contactSubType === 'Area Manager' ? (
                                <span
                                    className={`emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Area Manager`}
                                    data-pr-position="top"
                                >AM</span>
                            ) : contactSubType === 'Building Inspector' ? (
                                <span
                                    className={`emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Building Inspector`}
                                    data-pr-position="top"
                                >BI</span>
                            ) : contactSubType === 'Plan Check Engineer' ? (
                                <span
                                    className={`emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Plan Check Engineer`}
                                    data-pr-position="top"
                                >PCE</span>
                            ) : null}
                        </div>
                    </React.Fragment>
                ) : contactType === 'Professional' ? (
                    <React.Fragment>
                        <Tooltip
                            key={`pro_emp_type${rowData.contactId}`}
                            id={`pro_emp_type${rowData.contactId}`}
                            target={`.pro_emp_type${rowData.contactId}`}
                        />

                        <div className="table_row_data text-center">
                            {contactSubType === 'Company' ? (
                                <span
                                    className={`pro_emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Company Employee`}
                                    data-pr-position="top"
                                >CE</span>
                            ) : contactSubType === 'Self Employee' ? (
                                <span
                                    className={`pro_emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Self Employee`}
                                    data-pr-position="top"
                                >SE</span>
                            ) : null}
                        </div>
                    </React.Fragment>
                ) : contactType === 'Client' ? (
                    <React.Fragment>
                        <Tooltip
                            key={`cli_emp_type${rowData.contactId}`}
                            id={`cli_emp_type${rowData.contactId}`}
                            target={`.cli_emp_type${rowData.contactId}`}
                        />
                        <div className="table_row_data text-center">
                            {contactSubType === 'Commercial Client' ? (
                                <span
                                    className={`cli_emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Commercial Client`}
                                    data-pr-position="top"
                                >CC</span>
                            ) : contactSubType === 'Domestic Client' ? (
                                <span
                                    className={`cli_emp_type${rowData.contactId} emp_type_display`}
                                    data-pr-tooltip={`Domestic Client`}
                                    data-pr-position="top"
                                >DC</span>
                            ) : null}
                        </div>
                    </React.Fragment>
                ) : null}
            </React.Fragment>
        );
    }

    const viewContactBody = (contact: any) => {
        if (contact.contactType === 'Employee') {
            return (
                <div className="tabel_btn_area">
                    <Link
                        to={`/contact/employee/view`}
                        state={{ employee: contact }}
                        className="tabel_btn p-ripple"
                        onClick={() => handleViewEmployeeContact(contact)}>
                        View
                        <Ripple />
                    </Link>
                </div>
            )
        } else if (contact.contactType === 'Professional') {
            let contactURL = '';

            if (contact.contactSubType === "Company") {
                contactURL = "professional/company-employee/view";
            } else if (contact.contactSubType === "Self Employee") {
                contactURL = "professional/self-employee/view";
            }

            return (
                <div className="tabel_btn_area">
                    <Link
                        to={`${contactURL}`}
                        state={{ contact }}
                        className="tabel_btn p-ripple"
                        onClick={() => handleViewProfessionalContact(contact)}>
                        View
                        <Ripple />
                    </Link>
                </div>
            )
        } else if (contact.contactType === 'Client') {
            let contactURL = '';

            if (contact.contactSubType === "Commercial Client") {
                contactURL = "client/commercial-client/view";
            } else if (contact.contactSubType === "Domestic Client") {
                contactURL = "client/domestic-client/view";
            }

            return (
                <div className="tabel_btn_area">
                    <Link
                        to={`${contactURL}`}
                        state={{ contact }}
                        className="tabel_btn p-ripple"
                        onClick={() => handleViewClientContact(contact)}>
                        View
                        <Ripple />
                    </Link>
                </div>
            )
        }
    };
    /* ************************************************************************** */


    /* ************************** Employee contacts ***************************** */
    const onEmployeeTypeChange = (e: any) => {
        setSelectedEmployeeType(e.value);
    };



    const selectedEmployeeTypeTemplate = (option: 'Employee' | 'Temporary Employee' | 'Area Manager' | 'Building Inspector' | 'Plan Check Engineer', props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    {loginUserRoleName === 'building inspector company' ? (
                        <div>{option}</div>
                    ) : (
                        <div>{option === 'Employee' ? 'Permanent Employee' : option}</div>
                    )}
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const employeeTypeOptionTemplate = (option: 'Employee' | 'Temporary Employee' | 'Area Manager' | 'Building Inspector' | 'Plan Check Engineer') => {
        return (
            <div className="d-flex align-items-center">
                {loginUserRoleName === 'building inspector company' ? (
                    <div>{option}</div>
                ) : (
                    <div>{option === 'Employee' ? 'Permanent Employee' : option}</div>
                )}
            </div>
        );
    };

    const employeeTypeFilterElement = (
        <Dropdown
            value={selectedEmployeeType}
            options={validEmployeeTypes}
            onChange={onEmployeeTypeChange}
            valueTemplate={selectedEmployeeTypeTemplate}
            itemTemplate={employeeTypeOptionTemplate}
            placeholder="Select"
            className="p-column-filter"
            showClear
        />
    );

    const employeeTypeBody = (rowData: Employee) => {
        const contactSubType = rowData.contactSubType;

        return (
            <React.Fragment>
                <Tooltip
                    key={`emp_type${rowData.contactId}`}
                    id={`emp_type${rowData.contactId}`}
                    target={`.emp_type${rowData.contactId}`}
                />

                <div className="table_row_data text-center">
                    {contactSubType === 'Employee' ? (
                        <span
                            className={`emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`${loginUserRoleName === 'building inspector company' ? 'Employee' : 'Permanent Employee'}`}
                            data-pr-position="top"
                        >{loginUserRoleName === 'building inspector company' ? 'EM' : 'PE'}</span>
                    ) : contactSubType === 'Temporary Employee' ? (
                        <span
                            className={`emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Temporary Employee`}
                            data-pr-position="top"
                        >TE</span>
                    ) : contactSubType === 'Area Manager' ? (
                        <span
                            className={`emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Area Manager`}
                            data-pr-position="top"
                        >AM</span>
                    ) : contactSubType === 'Building Inspector' ? (
                        <span
                            className={`emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Building Inspector`}
                            data-pr-position="top"
                        >BI</span>
                    ) : contactSubType === 'Plan Check Engineer' ? (
                        <span
                            className={`emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Plan Check Engineer`}
                            data-pr-position="top"
                        >PCE</span>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }

    const contactAvatarBodyEmployee = (rowData: any) => {
        return (
            <div className="contact_avatar_area">
                <Avatar
                    image={`${rowData['profile_image']}`}
                    className="contact_avatar"
                    size="xlarge"
                    shape="circle"
                />
            </div>
        );
    };

    const handleViewEmployeeContact = (employee: Employee) => {
        dispatch(setSelectedEmployee(employee));
        goToTop();
    };

    const employeeViewContactBody = (employee: Employee) => {
        return (
            <div className="tabel_btn_area">
                <Link
                    to={`/contact/employee/view`}
                    state={{ employee }}
                    className="tabel_btn p-ripple"
                    onClick={() => handleViewEmployeeContact(employee)}>
                    View
                    <Ripple />
                </Link>
            </div>
        )
    };
    /* ************************************************************************** */


    /* ************************ Professional contacts *************************** */
    const onProfessionalTypeChange = (e: any) => {
        setSelectedProfessionalType(e.value);
    };

    const filteredProfessionalContacts = useMemo(() => {
        const searchKey = contactSearchKey.toLowerCase().trim();

        return professionals.filter(({ first_name, last_name, email, mobile, contactSubType }) => {
            const matchesType = !selectedProfessionalType || contactSubType === selectedProfessionalType;

            const matchesSearch =
                !searchKey ||
                (first_name ?? "").toLowerCase().includes(searchKey) ||
                (last_name ?? "").toLowerCase().includes(searchKey) ||
                (email ?? "").toLowerCase().includes(searchKey) ||
                (mobile ?? "").toLowerCase().includes(searchKey);

            return matchesType && matchesSearch;
        });
    }, [professionals, selectedProfessionalType, contactSearchKey]);

    const professionlEmployeeTypeFilterElement = (
        <Dropdown
            value={selectedProfessionalType}
            options={professionalEmployeeTypes}
            onChange={onProfessionalTypeChange}
            placeholder="Select"
            className="p-column-filter"
            showClear
        />
    );

    const professionalAvatarBodyEmployee = (rowData: Professional) => {
        var profile_image = '';

        if (rowData.contactSubType === "Company") {
            profile_image = rowData.subContact[0].profile_image;
        } else {
            profile_image = rowData.profile_image;
        }

        return (
            <div className="contact_avatar_area">
                <Avatar
                    image={`${profile_image}`}
                    className="contact_avatar"
                    size="xlarge"
                    shape="circle"
                />
            </div>
        );
    };

    const professionalNameBody = (rowData: Professional) => {
        var first_name = '';
        var last_name = '';

        if (rowData.contactSubType === "Company") {
            first_name = rowData.subContact[0].first_name;
            last_name = rowData.subContact[0].last_name;
        } else {
            first_name = rowData.first_name;
            last_name = rowData?.last_name;
        }
        return (
            <div className="table_row_data text-capitalize">
                {first_name || last_name ? `${first_name ?? ''} ${last_name ?? ''}`.trim() : '---'}
            </div>
        );
    }

    const professionalRoleBody = (rowData: Professional) => {
        var role_name = '';

        if (rowData.contactSubType === "Company") {
            role_name = rowData.subContact[0].role_name;
        } else {
            role_name = rowData.role_name;
        }
        return (
            <div className="table_row_data text-capitalize">
                {role_name ? role_name : '---'}
            </div>
        );
    }

    const professionalPhoneBody = (rowData: Professional) => {
        var primary_phone_no = '';

        if (rowData.contactSubType === "Company") {
            primary_phone_no = rowData.subContact[0].pimary_phone_no;
        } else {
            primary_phone_no = rowData.mobile;
        }

        return (
            <React.Fragment>
                {primary_phone_no ? (
                    <Link
                        to={`tel:${primary_phone_no}`}
                        className="text_no_wrap is_link is_contact_element phone"
                    >
                        {primary_phone_no}
                    </Link>
                ) : (
                    <span>---</span>
                )}
            </React.Fragment>
        );
    }

    const professionalEmployeeTypeBody = (rowData: Professional) => {
        const contactSubType = rowData.contactSubType;

        return (
            <React.Fragment>
                <Tooltip
                    key={`pro_emp_type${rowData.contactId}`}
                    id={`pro_emp_type${rowData.contactId}`}
                    target={`.pro_emp_type${rowData.contactId}`}
                />

                <div className="table_row_data text-center">
                    {contactSubType === 'Company' ? (
                        <span
                            className={`pro_emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Company Employee`}
                            data-pr-position="top"
                        >CE</span>
                    ) : contactSubType === 'Self Employee' ? (
                        <span
                            className={`pro_emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Self Employee`}
                            data-pr-position="top"
                        >SE</span>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }

    const handleViewProfessionalContact = (professional: Professional) => {
        dispatch(setSelectedProfessional(professional));
        goToTop();
    };

    const professionalViewContactBody = (rowData: Professional) => {
        var URL = '';

        if (rowData.contactSubType === "Company") {
            URL = "/contact/professional/company-employee/view";
        } else {
            URL = "/contact/professional/self-employee/view";
        }

        return (
            <div className="tabel_btn_area">
                <Link
                    to={`${URL}`}
                    state={{ rowData }}
                    className="tabel_btn p-ripple"
                    onClick={() => handleViewProfessionalContact(rowData)}>
                    View
                    <Ripple />
                </Link>
            </div>
        )
    };
    /* ************************************************************************* */


    /* ************************** Client contacts ****************************** */
    const onClientTypeChange = (e: any) => {
        setSelectedClientType(e.value);
    };

    const clientEmployeeTypeFilterElement = (
        <Dropdown
            value={selectedClientType}
            options={clientEmployeeTypes}
            onChange={onClientTypeChange}
            placeholder="Select"
            className="p-column-filter"
            showClear
        />
    );


    const filteredClientContacts = useMemo(() => {
        const searchKey = contactSearchKey.toLowerCase().trim();

        return clients.filter(({ first_name, last_name, email, mobile, contactSubType }) => {
            const matchesType = !selectedClientType || contactSubType === selectedClientType;

            const matchesSearch =
                !searchKey ||
                (first_name ?? "").toLowerCase().includes(searchKey) ||
                (last_name ?? "").toLowerCase().includes(searchKey) ||
                (email ?? "").toLowerCase().includes(searchKey) ||
                (mobile ?? "").toLowerCase().includes(searchKey);

            return matchesType && matchesSearch;
        });
    }, [clients, selectedClientType, contactSearchKey]);

    const contactAvatarBodyClient = (rowData: any) => {
        return (
            <div className="contact_avatar_area">
                <Avatar
                    image={`${rowData['profile_image']}`}
                    className="contact_avatar"
                    size="xlarge"
                    shape="circle"
                />
            </div>
        );
    };

    const clientEmployeeTypeBody = (rowData: Client) => {
        const contactSubType = rowData.contactSubType;
        return (
            <React.Fragment>
                <Tooltip
                    key={`cli_emp_type${rowData.contactId}`}
                    id={`cli_emp_type${rowData.contactId}`}
                    target={`.cli_emp_type${rowData.contactId}`}
                />
                <div className="table_row_data text-center">
                    {contactSubType === 'Commercial Client' ? (
                        <span
                            className={`cli_emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Commercial Client`}
                            data-pr-position="top"
                        >CC</span>
                    ) : contactSubType === 'Domestic Client' ? (
                        <span
                            className={`cli_emp_type${rowData.contactId} emp_type_display`}
                            data-pr-tooltip={`Domestic Client`}
                            data-pr-position="top"
                        >DC</span>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }

    const handleViewClientContact = (client: Client) => {
        if (client.contactSubType === 'Commercial Client') {
            dispatch(setSelectedComClient(client));
        } else if (client.contactSubType === 'Domestic Client') {
            dispatch(setSelectedDomClient(client));
        }
        goToTop();
    };

    const viewClientContactBody = (client: Client) => {
        if (client.contactSubType === 'Commercial Client') {
            return (
                <div className="tabel_btn_area">
                    <Link
                        to={`client/commercial-client/view`}
                        state={{ client }}
                        className="tabel_btn p-ripple"
                        onClick={() => handleViewClientContact(client)}
                    >
                        View
                        <Ripple />
                    </Link>
                </div>
            )
        } else {
            return (
                <div className="tabel_btn_area">
                    <Link
                        to={`client/domestic-client/view`}
                        state={{ client }}
                        className="tabel_btn p-ripple"
                        onClick={() => handleViewClientContact(client)}
                    >
                        View
                        <Ripple />
                    </Link>
                </div>
            )
        }
    };
    /* ************************************************************************* */


    const handleCloseAddContactTypeModal = () => {
        setShowAddContactTypeModal(false);
        setShowAddContactModal(true);
    }

    const handleSelectAddContact = (state: 'Employee' | 'Professional' | 'Client') => {
        setAddContactState(state);
        setShowAddContactModal(false);
        setShowAddContactTypeModal(true);
    }

    const addContacttypeModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add {addContactState} contact for
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseAddContactTypeModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );


    /*  */
    useEffect(() => {
        if (employeeTypes && employeeTypes.length > 0) {
            let validTypes: string[] = [];

            if (loginUserRoleName !== 'building inspector company') {
                validTypes = employeeTypes.filter(
                    (data) =>
                        data === 'Temporary Employee' ||
                        data === 'Employee'
                );
            } else {
                validTypes = employeeTypes.filter(
                    (data) =>
                        data !== 'Temporary Employee'
                );
            }

            setValidEmployeeTypes(validTypes);
        }
    }, [loginUserRoleName, employeeTypes]);

    return (
        <React.Fragment>
            <div className="main_content layout_padding show_side_bar">
                {loading ? (
                    <PageLoader />
                ) : error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div>
                        <h4 className="main_heading">Contact</h4>

                        <div className="page_content">
                            <div className="page_header_area">
                                <div className="contact_tabs_container">
                                    <ul className="contact_tabs mb-3" id="contact-tabs" role="tablist">
                                        {isPermissionAll && (
                                            <li className="contact_tab_item" role="presentation">
                                                <button
                                                    className={`contact_tab_btn p-ripple ${activeTab === 'all' ? 'active' : ''}`}
                                                    onClick={() => handleTabChange('all')}
                                                    id="all-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#all"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="all"
                                                    aria-selected={activeTab === 'all'}
                                                >
                                                    All&nbsp;:&nbsp;
                                                    <span>{String(allContacts?.length).padStart(2, '0')}</span>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                </button>
                                            </li>
                                        )}

                                        {isPermissionEmployee && (
                                            <li className="contact_tab_item" role="presentation">
                                                <button
                                                    className={`contact_tab_btn p-ripple ${activeTab === 'employee' ? 'active' : ''}`}
                                                    onClick={() => handleTabChange('employee')}
                                                    id="employee-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#employee"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="employee"
                                                    aria-selected={activeTab === 'employee'}
                                                >
                                                    Employee&nbsp;:&nbsp;
                                                    <span>{String(employees?.length).padStart(2, '0')}</span>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                </button>
                                            </li>
                                        )}

                                        {isPermissionProfessional && (
                                            <li className="contact_tab_item" role="presentation">
                                                <button
                                                    className={`contact_tab_btn p-ripple ${activeTab === 'professional' ? 'active' : ''}`}
                                                    onClick={() => handleTabChange('professional')}
                                                    id="professional-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#professional"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="professional"
                                                    aria-selected={activeTab === 'professional'}
                                                >
                                                    Professional&nbsp;:&nbsp;
                                                    <span>{String(professionals?.length).padStart(2, '0')}</span>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                </button>
                                            </li>
                                        )}

                                        {isPermissionClient && (
                                            <li className="contact_tab_item" role="presentation">
                                                <button
                                                    className={`contact_tab_btn p-ripple ${activeTab === 'client' ? 'active' : ''}`}
                                                    onClick={() => handleTabChange('client')}
                                                    id="client-tab"
                                                    data-bs-toggle="pill"
                                                    data-bs-target="#client"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="client"
                                                    aria-selected={activeTab === 'client'}
                                                >
                                                    Client&nbsp;:&nbsp;
                                                    <span>{String(clients?.length).padStart(2, '0')}</span>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                </div>

                                <div className="page_action_area wrap_flex">
                                    <div className="filter_input_group">
                                        <IconField iconPosition="right">
                                            {contactSearchKey === "" ? (
                                                <InputIcon className="bi bi-search"></InputIcon>
                                            ) : (
                                                <InputIcon
                                                    className="bi bi-x-lg search_clear_icon"
                                                    onClick={() => setContactSearchKey("")}
                                                ></InputIcon>
                                            )}

                                            <InputText
                                                key={`contactSearchKey`}
                                                id="contactSearchKey"
                                                value={contactSearchKey}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setContactSearchKey(e.target.value)
                                                }
                                                className="custom_form_input filter_input"
                                                placeholder="Search by name/email/mobile no."
                                                type="search"
                                            />
                                        </IconField>
                                    </div>

                                    {isPermissionAdd && (
                                        <Link to={'#'} onClick={() => setShowAddContactModal(true)} className="add_data_link_btn p-ripple">
                                            <i className="bi bi-plus-circle"></i>
                                            <span>Add contact</span>
                                            <Ripple />
                                        </Link>
                                    )}
                                </div>
                            </div>

                            <div className="tab-content contact_tab_content" id="contact-tabsContent">
                                {/* All contacts */}
                                {isPermissionAll && (
                                    <div className={`tab-pane fade ${activeTab === 'all' ? 'show active' : ''} `} id="all" role="tabpanel" aria-labelledby="all-tab" tabIndex={0}>
                                        <div className="page_table_area">
                                            <DataTable
                                                value={filteredAllContacts}
                                                paginator
                                                size="small"
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                tableStyle={{ minWidth: '50rem' }}
                                                paginatorDropdownAppendTo={'self'}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                className="page_table"
                                                emptyMessage="No contacts found!"
                                            >
                                                <Column
                                                    body={contactAvatarBody}
                                                    alignHeader="center"
                                                    className="table_image_area"
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    header="Name"
                                                    headerClassName="text_purple"
                                                    body={contactNameBody}
                                                    style={{ width: '25%' }}
                                                ></Column>

                                                <Column
                                                    header="Role"
                                                    headerClassName="text_purple"
                                                    body={contactRoleBody}
                                                    style={{ width: '18%' }}
                                                ></Column>

                                                <Column
                                                    header="Phone"
                                                    headerClassName="text_purple"
                                                    body={contactPhoneBody}
                                                    style={{ width: '17%' }}
                                                ></Column>

                                                <Column
                                                    header="Type"
                                                    headerClassName="text_purple"
                                                    field="contactType"
                                                    body={(rowData: any) => (
                                                        <span className="text-capitalize">
                                                            {rowData?.contactType ? rowData?.contactType : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    header="Sub type"
                                                    headerClassName="text_purple"
                                                    alignHeader="center"
                                                    body={contactSubTypeBody}
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    body={viewContactBody}
                                                    alignHeader="center"
                                                    className="table_btn_area"
                                                    style={{ width: '10%' }}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                )}
                                {/*  */}

                                {/* Employee contacts */}
                                {isPermissionEmployee && (
                                    <div className={`tab-pane fade ${activeTab === 'employee' ? 'show active' : ''} `} id="employee" role="tabpanel" aria-labelledby="employee-tab" tabIndex={0}>
                                        <div className="page_table_area">
                                            <DataTable
                                                value={filteredEmployeeContacts}
                                                paginator
                                                size="small"
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                tableStyle={{ minWidth: '50rem' }}
                                                paginatorDropdownAppendTo={'self'}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                className="page_table"
                                                emptyMessage="No contacts found!"
                                            >
                                                <Column
                                                    body={contactAvatarBodyEmployee}
                                                    alignHeader="center"
                                                    className="table_image_area"
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    header="Name"
                                                    headerClassName="text_purple"
                                                    field="first_name"
                                                    body={(rowData: Employee) => (
                                                        <span className="text-capitalize">
                                                            {(rowData?.first_name || rowData?.last_name)
                                                                ? `${rowData?.first_name ?? ''} ${rowData?.last_name ?? ''}`.trim()
                                                                : '---'
                                                            }
                                                        </span>
                                                    )}
                                                    style={{ width: '25%' }}
                                                ></Column>

                                                <Column
                                                    header="Role"
                                                    headerClassName="text_purple"
                                                    field="display_role_name"
                                                    body={(rowData: Employee) => (
                                                        <span className="text-capitalize">
                                                            {rowData?.display_role_name ? rowData?.display_role_name : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Phone"
                                                    headerClassName="text_purple"
                                                    field="mobile"
                                                    body={(rowData: Employee) => (
                                                        <React.Fragment>
                                                            {rowData?.mobile ? (
                                                                <Link
                                                                    to={`tel:${rowData?.mobile}`}
                                                                    className="is_link is_contact_element phone text_no_wrap"
                                                                >
                                                                    {rowData?.mobile}
                                                                </Link>
                                                            ) : (
                                                                <span>---</span>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Employee type"
                                                    headerClassName="text_purple"
                                                    alignHeader="center"
                                                    body={employeeTypeBody}
                                                    showFilterMenuOptions={false}
                                                    showFilterMatchModes={false}
                                                    showAddButton={false}
                                                    showApplyButton={false}
                                                    showClearButton={false}
                                                    filterElement={employeeTypeFilterElement}
                                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                                    filterMenuStyle={{ minWidth: '15rem' }}
                                                    filter
                                                    style={{ width: '15%' }}
                                                ></Column>

                                                <Column
                                                    body={employeeViewContactBody}
                                                    alignHeader="center"
                                                    className="table_btn_area"
                                                    style={{ width: '10%' }}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                )}
                                {/*  */}

                                {/* Professional contacts */}
                                {isPermissionProfessional && (
                                    <div className={`tab-pane fade ${activeTab === 'professional' ? 'show active' : ''} `} id="professional" role="tabpanel" aria-labelledby="professional-tab" tabIndex={0}>
                                        <div className="page_table_area">
                                            <DataTable
                                                value={filteredProfessionalContacts}
                                                paginator
                                                size="small"
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                tableStyle={{ minWidth: '50rem' }}
                                                paginatorDropdownAppendTo={'self'}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                className="page_table"
                                                emptyMessage="No contacts found!"
                                            >
                                                <Column
                                                    body={professionalAvatarBodyEmployee}
                                                    alignHeader="center"
                                                    className="table_image_area"
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    header="Name"
                                                    headerClassName="text_purple"
                                                    body={professionalNameBody}
                                                    style={{ width: '25%' }}
                                                ></Column>

                                                <Column
                                                    header="Role"
                                                    headerClassName="text_purple"
                                                    body={professionalRoleBody}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Phone"
                                                    headerClassName="text_purple"
                                                    body={professionalPhoneBody}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Employee type"
                                                    headerClassName="text_purple"
                                                    alignHeader="center"
                                                    body={professionalEmployeeTypeBody}
                                                    showFilterMenuOptions={false}
                                                    showFilterMatchModes={false}
                                                    showAddButton={false}
                                                    showApplyButton={false}
                                                    showClearButton={false}
                                                    filterElement={professionlEmployeeTypeFilterElement}
                                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                                    filterMenuStyle={{ minWidth: '15rem' }}
                                                    filter
                                                    style={{ width: '15%' }}
                                                ></Column>

                                                <Column
                                                    body={professionalViewContactBody}
                                                    alignHeader="center"
                                                    className="table_btn_area"
                                                    style={{ width: '10%' }}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                )}
                                {/*  */}

                                {/* Client contacts */}
                                {isPermissionClient && (
                                    <div className={`tab-pane fade ${activeTab === 'client' ? 'show active' : ''} `} id="client" role="tabpanel" aria-labelledby="client-tab" tabIndex={0}>
                                        <div className="page_table_area">
                                            <DataTable
                                                value={filteredClientContacts}
                                                paginator
                                                size="small"
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                tableStyle={{ minWidth: '50rem' }}
                                                paginatorDropdownAppendTo={'self'}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                className="page_table"
                                                emptyMessage="No contacts found!"
                                            >
                                                <Column
                                                    body={contactAvatarBodyClient}
                                                    alignHeader="center"
                                                    className="table_image_area"
                                                    style={{ width: '10%' }}
                                                ></Column>

                                                <Column
                                                    header="Name"
                                                    headerClassName="text_purple"
                                                    field="first_name"
                                                    body={(rowData: Client) => (
                                                        <span className="text-capitalize">
                                                            {(rowData?.first_name || rowData?.last_name)
                                                                ? `${rowData?.first_name ?? ''} ${rowData?.last_name ?? ''}`.trim()
                                                                : '---'
                                                            }
                                                        </span>
                                                    )}
                                                    style={{ width: '25%' }}
                                                ></Column>

                                                <Column
                                                    header="Role"
                                                    field="role_name"
                                                    headerClassName="text_purple"
                                                    body={(rowData: Client) => (
                                                        <span className="text-capitalize">
                                                            {rowData?.role_name ? rowData?.role_name : '---'}
                                                        </span>
                                                    )}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Phone"
                                                    field="mobile"
                                                    headerClassName="text_purple"
                                                    body={(rowData: Client) => (
                                                        <React.Fragment>
                                                            {rowData?.mobile ? (
                                                                <Link to={`tel:${rowData?.mobile}`} className="text-capitalize is_link is_contact_element phone">
                                                                    {rowData?.mobile}
                                                                </Link>
                                                            ) : (
                                                                <span>---</span>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                    style={{ width: '20%' }}
                                                ></Column>

                                                <Column
                                                    header="Client type"
                                                    alignHeader="center"
                                                    headerClassName="text_purple"
                                                    body={clientEmployeeTypeBody}
                                                    showFilterMenuOptions={false}
                                                    showFilterMatchModes={false}
                                                    showAddButton={false}
                                                    showApplyButton={false}
                                                    showClearButton={false}
                                                    filterElement={clientEmployeeTypeFilterElement}
                                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                                    filterMenuStyle={{ minWidth: '15rem' }}
                                                    filter
                                                    style={{ width: '15%' }}
                                                >
                                                </Column>

                                                <Column
                                                    body={viewClientContactBody}
                                                    alignHeader="center"
                                                    className="table_btn_area"
                                                    style={{ width: '10%' }}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                )}
                                {/*  */}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Add contact modal */}
            <Dialog
                visible={showAddContactModal}
                header={addContactModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseAddContactModal}
                dismissableMask
            >
                <div className="custom_modal_body overflow-hidden">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact_tabs justify-content-center w-75 mx-auto">
                                {isPermissionEmployee && (
                                    <div className="contact_tab_item w-100">
                                        <button
                                            className="contact_tab_btn active w-100 p-ripple"
                                            onClick={() => handleSelectAddContact('Employee')}
                                        >
                                            Employee
                                            <i className="bi bi-arrow-right ms-2"></i>
                                            <Ripple />
                                        </button>
                                    </div>
                                )}

                                {isPermissionProfessional && (
                                    <div className="contact_tab_item w-100">
                                        <button
                                            className="contact_tab_btn active w-100 p-ripple"
                                            onClick={() => handleSelectAddContact('Professional')}
                                        >
                                            Professional
                                            <i className="bi bi-arrow-right ms-2"></i>
                                            <Ripple />
                                        </button>
                                    </div>
                                )}

                                {isPermissionClient && (
                                    <div className="contact_tab_item w-100">
                                        <button
                                            className="contact_tab_btn active w-100 p-ripple"
                                            onClick={() => handleSelectAddContact('Client')}
                                        >
                                            Client
                                            <i className="bi bi-arrow-right ms-2"></i>
                                            <Ripple />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Add contact type modal */}
            <Dialog
                visible={showAddContactTypeModal}
                header={addContacttypeModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseAddContactTypeModal}
                dismissableMask
            >
                <div className="custom_modal_body overflow-hidden">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact_tabs justify-content-center w-75 mx-auto">
                                {isPermissionEmployee && addContactState === 'Employee' && (
                                    <React.Fragment>
                                        {loginUserRoleName === 'building inspector company' ? (
                                            <React.Fragment>
                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Area manager' }}
                                                    >
                                                        Area Manager
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>

                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Building inspector' }}
                                                    >
                                                        Building Inspector
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>

                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Plan check engineer' }}
                                                    >
                                                        Plan Check Engineer
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>

                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Employee' }}
                                                    >
                                                        Employee
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Permanent employee' }}
                                                    >
                                                        Permanent Employee
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>

                                                <div className="contact_tab_item w-100">
                                                    <Link
                                                        to={'/contact/employee/add'}
                                                        className="contact_tab_btn outlined w-100 p-ripple"
                                                        state={{ contactFor: 'Temporary employee' }}
                                                    >
                                                        Temporary Employee
                                                        <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                        <Ripple />
                                                    </Link>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )}

                                {isPermissionProfessional && addContactState === 'Professional' && (
                                    <React.Fragment>
                                        <div className="contact_tab_item w-100">
                                            <Link
                                                to={'/contact/professional/add'}
                                                className="contact_tab_btn outlined w-100 p-ripple"
                                                state={{ contactFor: 'Company employee' }}
                                            >
                                                Company Employee
                                                <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                <Ripple />
                                            </Link>
                                        </div>

                                        <div className="contact_tab_item w-100">
                                            <Link
                                                to={'/contact/professional/add'}
                                                className="contact_tab_btn outlined w-100 p-ripple"
                                                state={{ contactFor: 'Self employee' }}
                                            >
                                                Self Employee
                                                <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                <Ripple />
                                            </Link>
                                        </div>
                                    </React.Fragment>
                                )}

                                {isPermissionClient && addContactState === 'Client' && (
                                    <React.Fragment>
                                        <div className="contact_tab_item w-100">
                                            <Link
                                                to={'/contact/client/add'}
                                                className="contact_tab_btn outlined w-100 p-ripple"
                                                state={{ contactFor: 'Commercial client' }}
                                            >
                                                Commercial Client
                                                <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                <Ripple />
                                            </Link>
                                        </div>

                                        <div className="contact_tab_item w-100">
                                            <Link
                                                to={'/contact/client/add'}
                                                className="contact_tab_btn outlined w-100 p-ripple"
                                                state={{ contactFor: 'Domestic client' }}
                                            >
                                                Domestic Client
                                                <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                <Ripple />
                                            </Link>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
        </React.Fragment>
    )
}

export default Contact;